import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  useTheme,
} from "@mui/material";
import { Height } from "@mui/icons-material";

export const BarChart_SaveResult = ({ summaryResult = [], datalabels }) => {
  const theme = useTheme();
  const [data, setData] = useState(null);

  // const genColor = () => {
  //   var randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
  //   return randomColor;
  // };

  const ColorPool = [
    "#ba68c8",
    "#F97427",
    "#4caf50",
    "#ffe200",
    "#35aeac",
    "#13e1ce",
    "#2a51da",
    "#5f72f0",
    "#d1fe87",
    "#005c55",
    "#baa0b2",
    "#57cda3",
    "#a1a770",
    "#552336",
    "#3e7e4f",
    "#dfd7a8",
    "#66702d",
    "#edc1e2",
    "#329702",
    "#a15d8c",
    "#623453",
    "#a85142",
    "#506c0b",
    "#24119b",
    "#c0926f",
    "#6e26c3",
    "#dadd24",
    "#d94953",
    "#5f8fac",
    "#bcd7f3",
  ];

  ColorPool.splice(0, 1 - summaryResult.length);

  useEffect(() => {
    const setLocalAgentState = () => {
      if (summaryResult) {
        setData({
          datasets: [
            {
              data: summaryResult.map((x) => x.datacount),
              // backgroundColor: summaryResult.map((index) => genColor(index)),
              backgroundColor: ColorPool,
              borderWidth: 1,
              borderColor: "#FFFFFF",
              hoverBorderColor: "#FFFFFF",
              datalabels: {
                anchor: "center",
                align: "center",
              },
            },
          ],
          labels: summaryResult.map((x) => x.StatusName),
        });
      }
    };
    setLocalAgentState();
  }, []);

  const options = {
    cornerRadius: 20,
    layout: { padding: 0 },
    plugins: { datalabels, legend: { display: false } },
    maintainAspectRatio: false,
    responsive: true,
    xAxes: [
      {
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider,
        },
      },
    ],
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
  };

  return (
    <div style={{ height: 380, paddingTop: 10 }}>
      {data ? <Bar data={data} options={options} /> : ""}
    </div>
  );
};

export default BarChart_SaveResult;
